import { createLazyFileRoute } from "@tanstack/react-router";

import { Section } from "@/features/admin/components/Section";
import { FieldSpecDetailForm } from "@/features/admin/components/tubes/FieldSpecDetailForm";

export const Route = createLazyFileRoute("/_auth/admin/tubes/fields/new")({
  component: NewFieldPage,
});

function NewFieldPage() {
  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>New field</Section.Title>
      <FieldSpecDetailForm />
    </div>
  );
}
